(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yohauz-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class YohauzCollectionTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.tabs = [...this.querySelectorAll('[data-tab-index]')];
      this.panels = [...this.querySelectorAll('[data-tab-panel]')];

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.setActiveTab(Number(tab.dataset.tabIndex), true));
        tab.addEventListener('keydown', (event) => this.handleTabKeydown(event));
      });

      this.querySelectorAll('[data-carousel-prev]').forEach((button) => {
        button.addEventListener('click', () => this.moveCarousel(button, -1));
      });

      this.querySelectorAll('[data-carousel-next]').forEach((button) => {
        button.addEventListener('click', () => this.moveCarousel(button, 1));
      });

      this.querySelectorAll('[data-carousel]').forEach((carousel) => {
        carousel.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.moveCarouselForTrack(carousel, event.key === 'ArrowRight' ? 1 : -1);
          }
        });
      });
    }

    setActiveTab(index, moveFocus) {
      const nextTab = this.tabs[index];
      if (!nextTab) return;

      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
      });

      if (moveFocus) nextTab.focus();
    }

    handleTabKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;

      if (nextIndex !== currentIndex) {
        event.preventDefault();
        this.setActiveTab(nextIndex, true);
      }
    }

    moveCarousel(button, direction) {
      const carousel = document.getElementById(button.getAttribute('aria-controls'));
      if (carousel) this.moveCarouselForTrack(carousel, direction);
    }

    moveCarouselForTrack(carousel, direction) {
      const slide = carousel.querySelector('[data-carousel-slide]');
      const gap = parseFloat(getComputedStyle(carousel).columnGap) || 0;
      const distance = (slide ? slide.getBoundingClientRect().width : carousel.clientWidth) + gap;
      carousel.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }
  }

  if (!customElements.get('yohauz-collection-tabs')) {
    customElements.define('yohauz-collection-tabs', YohauzCollectionTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
